import React from "react";
import DrawingDimension from "./DrawingDimension";
import { getViewportLayoutMm } from "../../engine/sheetLayoutUtils";

export default function DrawingDimensionLayer({
  annotations = [],
  viewport,
  view,
  active = false,
  selectedAnnotationId,
  onSelectAnnotation,
  onUpdateAnnotation,
  screenPxPerMm = 3,
}) {
  const layout = getViewportLayoutMm(viewport);

  if (!annotations.length) return null;

  return (
    <svg
  className="absolute inset-0"
  width="100%"
  height="100%"
  viewBox={`0 0 ${layout.widthMm} ${layout.heightMm}`}
  style={{
    zIndex: 90,
    pointerEvents: active ? "auto" : "none",
  }}
>
      {annotations
        .filter((ann) => ann.type === "dimension")
        .map((ann) => (
          <DrawingDimension
  key={ann.id}
  annotation={ann}
  viewport={viewport}
  view={view}
  selected={String(selectedAnnotationId) === String(ann.id)}
  active={active}
  screenPxPerMm={screenPxPerMm}
  onSelect={() => onSelectAnnotation?.(ann.id)}
  onUpdate={(patch) => onUpdateAnnotation?.(ann.id, patch)}
/>
        ))}
    </svg>
  );
}